export const generateMessageId = () => {
  return crypto.randomUUID();
};
